/*
 * Hides the theme's redundant "Sold out" button while the REZ notify widget is showing
 * its own "Notify me" button for the same variant.
 *
 * Without this, both buttons stack inside .product-form__buttons on a sold-out variant.
 * That makes the fixed sticky bar ~45px taller, and since the bar is white it covers
 * that much more of the page — which reads as a block of white space above it.
 *
 * Why this is JS rather than a CSS :has() rule. During a variant change the theme's own
 * script and the REZ app both mutate these buttons over a second or two: the theme can
 * set `disabled` before REZ has rendered its replacement. A CSS rule keyed on [disabled]
 * therefore hides the theme's button during a window when REZ has nothing on screen,
 * leaving no button at all.
 *
 * The ordering here is what makes it safe:
 *   1. Any variant change restores the theme's button immediately, before anything else.
 *   2. It is only hidden again once a REZ button is genuinely rendered (offsetHeight > 0)
 *      AND the theme's own button is disabled.
 * So there is no frame where both are missing. If this script fails to load, nothing is
 * ever hidden and the page behaves exactly as it does today.
 */
(function () {
  if (window.__soldOutButtonDedupe) return;
  window.__soldOutButtonDedupe = true;

  var CLASS = 'submit-superseded-by-notify';
  var RECHECK_MS = [80, 300, 700, 1400, 2400, 3600];

  var style = document.createElement('style');
  style.textContent = '.' + CLASS + '{display:none !important;}';
  document.head.appendChild(style);

  // Guards against our own class changes re-entering the observer.
  var applying = false;

  function restore() {
    applying = true;
    document.querySelectorAll('.' + CLASS).forEach(function (node) {
      node.classList.remove(CLASS);
    });
    applying = false;
  }

  function sync() {
    applying = true;
    document.querySelectorAll('.product-form__buttons').forEach(function (box) {
      var submit = box.querySelector('.product-form__submit');
      if (!submit) return;

      var notify = box.querySelector('.rez-stock-notification-button');
      var notifyShowing = !!notify && notify.offsetHeight > 0;

      if (notifyShowing && submit.hasAttribute('disabled')) {
        submit.classList.add(CLASS);
      } else {
        submit.classList.remove(CLASS);
      }
    });
    applying = false;
  }

  // Restore first, then re-evaluate as the theme and REZ settle.
  function onVariantChange() {
    restore();
    RECHECK_MS.forEach(function (delay) {
      setTimeout(sync, delay);
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (t && t.matches && t.matches('input[type="radio"], select')) onVariantChange();
    },
    true
  );

  // The theme renders its pickers as labels over visually hidden radios.
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (t && t.closest && t.closest('.product-form__input, variant-radios, variant-selects')) {
        onVariantChange();
      }
    },
    true
  );

  var observer = new MutationObserver(function () {
    if (applying) return;
    sync();
  });

  function observe() {
    var roots = document.querySelectorAll('.product__info-container, #stickyPurchaseBar');
    roots.forEach(function (root) {
      // Deliberately childList only. Watching attributes here as well fires
      // constantly — other apps and the media slider restyle elements inside this
      // container — which puts sync() in a tight loop and locks up the page. The
      // variant-change handler above already covers restyling, since that is the
      // only realistic way REZ's button disappears.
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  function init() {
    observe();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function () {
    restore();
    observe();
    setTimeout(sync, 300);
  });
})();
